import React from 'react';

class CopyRight extends React.Component {
  render() {
    return (
      <div className="stepfooter">
        <p>Copyright(C) WorkPath Inc. All Rights Reserved.</p>
      </div>
    );
  }
}

export default CopyRight;
